import { render, staticRenderFns } from "./ClinicCheckout.vue?vue&type=template&id=3617a96b&scoped=true&"
import script from "./ClinicCheckout.vue?vue&type=script&lang=js&"
export * from "./ClinicCheckout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3617a96b",
  null
  
)

export default component.exports